import React, { useState } from 'react';


const RFQsQuotes = () => {
  const [selectedOption, setSelectedOption] = useState('RFQ');

  return (
    <div>
    <div className="border-2 border-gray-200 h-96 rounded-2xl p-5">
      <div className="border-b pb-2 flex justify-between items-center">
        <h1 className="text-xl text-gray-600 font-semibold">RFQ's Quotes</h1>
      </div>

      <div className="flex gap-4 py-6">
        <div>
          <input
            type="radio"
            name="choose"
            value="RFQ"
            id="rfq"
            checked={selectedOption === 'RFQ'}
            onChange={() => setSelectedOption('RFQ')}
          />
          <label htmlFor="rfq" className="ps-1 text-oceanBlue">RFQ's</label>
        </div>

        <div>
          <input
            type="radio"
            name="choose"
            value="Quotes"
            id="quotes"
            checked={selectedOption === 'Quotes'}
            onChange={() => setSelectedOption('Quotes')}
          />
          <label htmlFor="quotes" className="ps-1 text-oceanBlue">Quotes</label>
     
      </div>
         </div>
    
    </div>
      <div className="mt-3">
          <Pagination />
        </div>
       </div>
      
       
  );
};

export default RFQsQuotes;
function Pagination() {
  const [pageSize, setPageSize] = useState(20);

  const handlePageSize = (value) => {
    setPageSize(Number(value));
  };
  return (
    <div>
      {/* Pagination */}
      <div
        className={`border w-fit border-gray-300 border-collapse rounded text-gray-500 flex items-center opacity-100 group-hover:cursor-pointer`}
      >
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 20 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          20
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 100 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          100
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 2500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          2500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer ${pageSize === 5000 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          5000
        </div>
      </div>


      {/*  */
      }


    </div>
  );
}

